module.exports = __webpack_public_path__ + "63d1e3107ccf4016bcaa7d55654a3a7b.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/Planilha_direcionamento_Tecon.xlsx
// module id = ./src/assets/downloads/Planilha_direcionamento_Tecon.xlsx
// module chunks = 1